(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var popup = document.getElementById('drink-pop');
    if (!popup || popup.dataset.ready === 'true') return;
    popup.dataset.ready = 'true';
    var key = 'drinkPopSeen';
    var box = popup.querySelector('.drink-pop__box');
    var ask = popup.querySelector('[data-drink-pop-ask]');
    var done = popup.querySelector('[data-drink-pop-done]');
    var previousFocus;
    function focusable() {
      return Array.from(box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (item) {
        return !item.closest('[hidden]');
      });
    }
    function open() {
      previousFocus = document.activeElement;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(function () {
        var items = focusable();
        (items[0] || box).focus();
      });
    }
    function close() {
      popup.hidden = true;
      document.body.style.overflow = '';
      try { localStorage.setItem(key, '1'); } catch (error) {}
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }
    popup.querySelectorAll('[data-drink-pop-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      var items = focusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    if (/customer_posted=true/.test(window.location.search)) {
      ask.hidden = true;
      done.hidden = false;
      open();
      try { localStorage.setItem(key, '1'); } catch (error) {}
      return;
    }
    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (error) {}
    if (seen) return;
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      open();
    }
    window.setTimeout(fire, 12000);
    document.addEventListener('mouseout', function (event) {
      if (!event.relatedTarget && event.clientY <= 0) fire();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
